import styled from 'styled-components';
import { Input } from 'antd';
import { StyledFormItem } from '../styled';

export const FormItemWith50 = styled(StyledFormItem)`
  width: 50%;
`;

export const FormItemWith40 = styled(StyledFormItem)`
  width: 40%;
`;

export const FormItemWith20 = styled(StyledFormItem)`
  width: 20%;
`;

export const FormItemWith30 = styled(StyledFormItem)`
  width: 30%;
`;

export const InlineContainer = styled.div`
  display: flex;
  .ant-form-item:not(:first-child) {
    margin-left: 16px;
  }
`;

export const StyldAnchor = styled.a`
  font-size: 12px;
  color: #21b4b;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button {
    margin-right: 16px;
  }
`;

export const WeightageInput = styled(Input)`
  width: 120px;
  color: rgba(0, 0, 0, 0.65) !important;
`;

export const LabelContainer = styled.div`
  margin-left: 8px;
  margin-top: 30px;
  span:first-child {
    margin-right: 16px;
  }
`;

export const StyledLabel = styled.span`
  background-color: #eef4fa;
  color: #2b73e0;
  padding: 6px 8px;
  border-radius: 16px;
  font-size: 12px;
  cursor: pointer;
`;
